import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// Hard Guard: Log missing keys in development.
// Signature mirrors i18next's MissingKeyHandler:
//   (lngs: readonly string[], ns: string, key: string, fallbackValue: string,
//    updateMissing: boolean, options: any) => void
const missingKeyHandler = (_lngs: readonly string[], ns: string, key: string) => {
  if (import.meta.env.DEV) {
    console.warn(`[i18n] Missing key: "${key}" in namespace "${ns}"`);
  }
};

// Default language priority:
//   1. User explicit choice (localStorage 'i18nextLng')
//   2. APK default (German) — set during the Capacitor build
//   3. Fallback: en
// The Capacitor `Capacitor.isNativePlatform()` check makes the APK default to
// German; the web build keeps language detection from the browser.
function pickDefaultLng(): string {
  const stored = typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
  if (stored) return stored;
  // Native (APK) → DE per product requirement
  try {
    // Avoid hard import so SSR / web builds don't pull Capacitor.
    const cap = (window as any)?.Capacitor;
    if (cap?.isNativePlatform?.()) return 'de';
  } catch { /* not running under Capacitor */ }
  return 'en';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: pickDefaultLng(),
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    // Ensure missing translations use the inline defaultValue (2nd arg to t())
    saveMissing: false,
    missingKeyHandler,
  });

// Save language preference to localStorage on change and apply RTL layout if needed
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
  if (lng.startsWith('ar')) {
    document.documentElement.dir = 'rtl';
  } else {
    document.documentElement.dir = 'ltr';
  }
});

// Set initial direction
if (i18n.language && i18n.language.startsWith('ar')) {
  document.documentElement.dir = 'rtl';
}

export default i18n;
